var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DC19AA29-C7B1-4CD1-9AD3-EA58A87F088F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kolo---Final---Internas",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-1.1-Alertas",
    transform: "translate(-972.000000, -471.000000)",
    fill: "#226095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/date-Copy-24",
    transform: "translate(972.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0 C55.8989868,0 72,16.1037598 72,36 C72,55.8989868 55.8962402,72 36,72 C16.1010132,72 0,55.8962402 0,36 C0,16.1010132 16.1037598,0 36,0 Z M36,5.625 C19.2101441,5.625 5.625,19.2123413 5.625,36 C5.625,52.7898559 19.2123413,66.375 36,66.375 C52.7898559,66.375 66.375,52.7876587 66.375,36 C66.375,19.2101441 52.7876587,5.625 36,5.625 Z M36,48 C37.6568542,48 39,49.3431458 39,51 C39,52.6568542 37.6568542,54 36,54 C34.3431458,54 33,52.6568542 33,51 C33,49.3431458 34.3431458,48 36,48 Z M36,15 C37.6569,15 39,16.5914167 39,18.5546498 L39,18.5546498 L39,41.4453502 C39,43.4085833 37.6569,45 36,45 C34.3431,45 33,43.4085833 33,41.4453502 L33,41.4453502 L33,18.5548275 C33,16.5915944 34.3431,15 36,15 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert-warning.5f172e537fd3a3b632520918abbff10d.svg";
export { ForwardRef as ReactComponent };